module.exports = __webpack_public_path__ + "static/media/IMG_9184.7562345b.jpg";